// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.allig-select-per-page .allig-per-page-select[data-v-95bfbce2] {\r\n  flex: 0 0 0;\r\n  white-space: nowrap;\n}\r\n", ""]);
// Exports
module.exports = exports;
